export enum UpdateOrderStatusEnum {
    OriginalFromShip = 1,
    UpdatedByShip = 2,
    UpdatedByOperator = 3,
}
